import React from 'react';

/**
 * Centered card used by the auth screens (currently just login).
 */
const AuthCard = ({ children, footer }) => {
  return (
    <div className="min-vh-100 d-flex flex-column align-items-center px-3" style={{ paddingTop: '10vh' }}>
      <div className="d-flex align-items-center gap-2 mb-4">
        <span className="fs-5 fw-semibold">ワンナイト人狼AI</span>
      </div>
      <div className="gh-box" style={{ width: '100%', maxWidth: '400px' }}>
        <div className="gh-box-body" style={{ padding: '28px' }}>{children}</div>
      </div>
      {footer && <div className="mt-3 text-muted-gh">{footer}</div>}
    </div>
  );
};

export default AuthCard;
